<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="menu.validConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(classification)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading" :max-height="780">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="itemCategory.no" title="business.label.categoryNo"/>
        <vxe-column field="itemCategory.name" title="business.label.categoryName"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="days" title="business.label.daysOfValid"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" title="menu.validConfig" type="confirm" width="40%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>onCategorySelect(),clear:()=>onCategoryChange([])}}" field="itemCategory.no" title="business.label.categoryNo"/>
        <vxe-form-item :item-render="{name:'VxeInput',props:{disabled:true}}" field="itemCategory.name" title="business.label.categoryName"/>
        <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>onItemSelect(),clear:()=>onInputChange(config,'item')}}" field="item.name" title="business.label.itemName"/>
        <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="days" title="business.label.daysOfValid"/>
      </vxe-form>
    </vxe-modal>
    <field-modal ref="itemCategoryModal" :no=itemCategoryNo :show-value="false" :title="$t('business.label.itemCategory')" @change="onCategoryChange"/>
    <item-modal ref="itemModal" @change="(values)=>onInputChange(config,'item',values[0])"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import FieldModal from '@/views/modal/FieldModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { ValidityConfig } from '@/api/dto/config/ValidityConfig'
import { onInputChange } from '@/utils/util'

export default {
  components: { ItemModal, FieldModal },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      visible: false,
      classification: new Dictionary(),
      list: [],
      config: new ValidityConfig(),
      itemCategoryNo: '',
      rules: {
        'itemCategory.no': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        days: [{ required: true, type: 'number', message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  created() {
    findOne('parameterFactory', { name: '商品类别层级' }).then(res => {
      if (res.success) {
        this.itemCategoryNo = res.result.value
      }
    })
  },
  methods: {
    onInputChange,
    onCategorySelect() {
      this.$refs.itemCategoryModal.open({ no: this.itemCategoryNo, available: true }, this.config, this.config.itemCategory)
    },
    onCategoryChange(values) {
      this.config.itemCategory = new Dictionary(values[0])
    },
    onItemSelect() {
      this.$refs.itemModal.open({ available: true }, this.config, this.config.item)
    },
    refresh(classification) {
      this.classification = classification
      if (this.classification.isNew()) {
        return this.$message.warning('请先选择字典项')
      }
      this.loading = true
      findAll('validityConfigFactory', { 'classification.id': this.classification.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new ValidityConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new ValidityConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('validityConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new ValidityConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      config.classification = this.classification
      save('validityConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new ValidityConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.classification)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('validityConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.classification)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>